(() => {
  if (window.FRMobileHeaderSearch) return;
  window.FRMobileHeaderSearch = true;
  function setOpen(header, open, restoreFocus) {
    const toggle = header.querySelector('[data-fr-mobile-search-toggle]');
    const row = header.querySelector('[data-fr-header-search-slot]');
    if (!toggle || !row) return;
    toggle.setAttribute('aria-expanded', String(open));
    row.hidden = !open;
    header.toggleAttribute('data-fr-search-open', open);
    if (open) row.querySelector('input[type="search"]')?.focus({preventScroll: true});
    else if (restoreFocus) toggle.focus({preventScroll: true});
  }
  document.addEventListener('click', event => {
    const toggle = event.target.closest('[data-fr-mobile-search-toggle]');
    if (!toggle) return;
    const header = toggle.closest('.fr-mobile-header');
    if (header) setOpen(header, toggle.getAttribute('aria-expanded') !== 'true', false);
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const header = event.target.closest('.fr-mobile-header[data-fr-search-open]');
    if (!header) return;
    event.preventDefault();
    setOpen(header, false, true);
  });
})();
